import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowId.actions.templateSettings', {
    msgTemplateSettingsUpdatedSuccess: 'Your settings have been saved.',
});
